import React, { Component } from 'react'
import { Mutation, Query } from 'react-apollo'
import { gql } from 'apollo-boost'
import { Field, Control, Input, Title, Subtitle, Button } from 'bloomer'
import { Link, Redirect } from 'react-router-dom'

import { AUTH_TOKEN_KEY } from '../../constants'

const REGISTER_AS_MEMBER = gql`
  mutation ($invitationId: UUID!, $username: String!, $password: String!, $firstName: String!, $lastName: String!) {
    registerMember(invitationId: $invitationId, username: $username, password: $password, firstName: $firstName, lastName: $lastName) {
      user { id, username, email, firstName, lastName }
    }
  }
`

const GET_INVITATION = gql`
  query ($invitationId: UUID!) {
    invitation(invitationId: $invitationId) { id, email, house { owner { id, firstName }} }
  }
`

const LOGIN = gql`
  mutation Login($username: String!, $password: String!) {
    tokenAuth(username: $username, password: $password) {
      token
    }
  }
`

class SignUpForm extends Component {

  state = {
    firstName: '',
    lastName: '',
    username: '',
    password: '',
    isLoading: false
  }

  handleChange = (key) => (evt) => {
    const value = evt.target.value
    this.setState(() => ({[key]: value}))
  }

  validate = () => {
    const { username, password, firstName, lastName } = this.state

    return !(
      username === '' ||
      password === '' ||
      firstName === '' ||
      lastName === ''
    )
  }

  handleSubmit = async (loginMutation, registerMutation, evt) => {
    evt.preventDefault()

    const { loginHandler, match: { params: { invitationId }} } = this.props
    const { username, password, firstName, lastName } = this.state

    if (!this.validate()) {
      return
    }

    this.setState(() => ({ isLoading: true }))
    localStorage.removeItem(AUTH_TOKEN_KEY)
    try {
      await registerMutation({
        variables: { username, password, firstName, lastName, invitationId }
      })

      const result = await loginMutation({
        variables: { username, password }
      })

      const { token } = result.data.tokenAuth
      localStorage.setItem(AUTH_TOKEN_KEY, token)
      await loginHandler()
    } catch (e) {
      this.setState(() => ({ isLoading: false }))
    }
  }

  render() {
    const { username, password, firstName, lastName, isLoading } = this.state
    const { match: {params: {invitationId}} } = this.props

    return (
      <Query query={GET_INVITATION} variables={{invitationId}}>
      {({loading, error, data}) => {
        if (loading) {
          return <p>Loading...</p>
        }

        if (error) {
          return <Redirect to="/" />
        }

        return (
          <Mutation mutation={LOGIN}>
            {(login) => (
              <Mutation mutation={REGISTER_AS_MEMBER}>
              {register => (
                <form onSubmit={this.handleSubmit.bind(this, login, register)}>
                  <Title isSize={3}>Aceitar o convite de {data.invitation.house.owner.firstName}</Title>
                  <Subtitle isSize={5}>Antes de tudo, crie uma conta</Subtitle>
                  <Field>
                    <Control>
                      <Input type="text" placeholder="Nome" autoFocus onChange={this.handleChange('firstName').bind(this)} value={firstName} />
                    </Control>
                  </Field>
                  <Field>
                    <Control>
                      <Input type="text" placeholder="Sobrenome" onChange={this.handleChange('lastName').bind(this)} value={lastName} />
                    </Control>
                  </Field>
                  <Field>
                    <Control>
                      <Input type="text" placeholder="Usuário" onChange={this.handleChange('username').bind(this)} value={username} />
                    </Control>
                  </Field>
                  <Field>
                    <Control>
                      <Input type="password" placeholder="Senha" onChange={this.handleChange('password').bind(this)} value={password} />
                    </Control>
                  </Field>
                  <Field>
                    <Button isColor="primary" type="submit" isFullWidth isLoading={isLoading}>Criar</Button>
                  </Field>
                  <Button render={(props) => <Link {...props} to="/login"/>} isFullWidth className="is-text">Já tenho conta</Button>
                </form>
              )}
              </Mutation>
            )}
          </Mutation>
        )
      }}
      </Query>
    )
  }
}

export default SignUpForm



// WEBPACK FOOTER //
// ./src/pages/IdentificationPage/InvitationSignUpForm.js